var ToggleComponent = (function () {
    function ToggleComponent() {
    }
    ToggleComponent.prototype.ngOnInit = function () {
    };
    return ToggleComponent;
}());
export { ToggleComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/toggle/toggle.component.ts.pre-build-optimizer.js